import React, { useMemo, useState, useEffect } from 'react';
import { Tile, Button, Loading } from '@cv/eds-react';
import '../CustomEDSComponents/configuration.css';
import { Input } from '@cv/eds-react/lib/components/input';
import { Select, SelectOption } from '@cv/eds-react/lib/components/select';
import validator from '@rjsf/validator-ajv8';
import {
  RJSFSchema,
  UiSchema,
  WidgetProps,
  RegistryWidgetsType,
  ErrorListProps
} from '@rjsf/utils';
import Form from '@rjsf/core';
import useGetExportDashboardSchema from '../../hooks/useGetExportDashboardSchema';
import useGetEditDashboardById from '../../hooks/useGetEditDashboardById';
import useCustomerData from '../../Context/CustomerDataContext';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import usePostExportData from '../../hooks/usePostExportData';
import { notification } from '@cv/eds-react/lib/components/notification';
import { useHistory } from 'react-router-dom';
import {
  CustomEDSInput,
  CustomEDSSelect
} from '../CustomEDSComponents';
import { useQueryClient } from 'react-query';
import useGetDashboardListData from '../../hooks/useGetDashboardListData';

const EditDashboard = (props) => {
  const { dashboard_id } = useParams();
  const { customer } = useCustomerData();
  const [schemaData, setSchemaData] = useState({});
  const history = useHistory();
  const queryClient = useQueryClient();
  // Get Dashboard Schema Data
  const { data: respDashboardSchemaData } = useGetExportDashboardSchema(customer);
  const { data: respDashboardData } = useGetDashboardListData(customer);

  useEffect(() => {
  if (respDashboardSchemaData?.data) {
    const modifiedSchema = { ...respDashboardSchemaData.data };

    if (modifiedSchema.properties?.visualisation?.items) {
      const items = modifiedSchema.properties.visualisation.items;

      items.enum = ['', ...(items.enum || [])];
      items.enumNames = ['-- Select --', ...(items.enumNames || [])];
    }

    setSchemaData(modifiedSchema);
  }
}, [respDashboardSchemaData]);

  // Edit Dashboard
  const { data: editFormData } = useGetEditDashboardById(customer, dashboard_id);
  
  useEffect(() => {
    setJsonData(editFormData?.data);
  }, [editFormData?.data]);

  // Create Dashboard
  const postApiURL = '/config/' + customer + '/dashboard';
  const { 
    mutateAsync,
    isLoading,
    isError,
    error  
  } = usePostExportData(postApiURL);

  const widgets: RegistryWidgetsType = {
    TextWidget: CustomEDSInput,
    SelectWidget: CustomEDSSelect
  };
  const schemaObject: RJSFSchema = useMemo(() => {
  if (!schemaData) return {};

  const newSchema = { ...schemaData };

  if (newSchema.properties?.visualisation?.enum) {
    newSchema.properties.visualisation.enum = [
      '', // blank first option
      ...newSchema.properties.visualisation.enum
    ];
  }

  return newSchema;
}, [schemaData]);

  const [pageTitle, setPageTitle] = useState('');
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/new-dashboard') {
      setPageTitle("New Dashboard");
    } else {
      setPageTitle("Edit Dashboard");
    }
  });

  const uiSchemaObject: UiSchema = {
    'ui:classNames': 'custom-form', 
    id: {
      'ui:widget': 'hidden',
      'ui:classNames': 'custom-field w-50',
    },
    name: {
      'ui:classNames': 'custom-field w-50',
    },
    columns: {
      'ui:classNames': 'custom-field w-50',
    },
    visualisation: {
      'ui:classNames': 'array-card w-100 position-relative',
      'ui:options': {
        orderable: false,
      },
      items: {
        'ui:classNames': 'custom-field w-50',
      }
    },
  };

  function transformErrors(errors, uiSchema) {
    return errors.map((error) => {
      return error;
    });
  }
  function ErrorListTemplate(props: ErrorListProps) {
    const { errors } = props;
    return (<></>
    );
  }

  const [jsonData, setJsonData] = useState({});
  const handleSubmitObject = async ({ formData }, e) => {
      try {
        const response = await mutateAsync(formData);
        if (response.error) {
          setTimeout(() => {
            notification.notice("Some error occured. please try again after sometime.");
          }, 1000);
        } else {
          notification.notice('Dashboard Added successfully!!!');
          queryClient.invalidateQueries(["dashboardData", customer]);
          history.push('/admin-dashboard');
        }
      } catch (error) {
        setTimeout(() => {
          notification.notice(error?.response?.data?.message);
        }, 1000);
      }
  };
  const handleErrorObject = (e) => {
    e.forEach((error) => {
      notification.notice(error?.stack);
    });
  };
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        {/* <Loading size="medium" /> */}
      </div>
    );
  } else if (isError) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <p>
          {error?.message ? error?.message : 'Something went wrong please try again.'}
        </p>
      </div>
    );
  } else {
    return (
      <>
      <Tile>
        <Form
          schema={schemaObject}
          uiSchema={uiSchemaObject}
          onSubmit={handleSubmitObject}
          onError={handleErrorObject}
          widgets={widgets}
          validator={validator}
          formData={jsonData}
          transformErrors={transformErrors}
          liveValidate
          templates={{ ErrorListTemplate }}
        >
          <>
            <Button type="submit" children="Submit" />
          </>
        </Form>
      </Tile>
    </>
    );
  }
};

export default EditDashboard;
